if (!customElements.get('atelier-order-button')) {
  customElements.define('atelier-order-button', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info') || document.querySelector('product-info[id^=MainProduct-]');
      this.surface = this.querySelector('.atelier-order-surface');
      if (!this.surface || !this.scope) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      if (this.dataset.appButton !== 'true') {
      this.button = this.surface.querySelector('button');
      this.price = Number(this.dataset.price);
      this.available = this.dataset.available === 'true';

      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency });
      this.sync = () => {
        const input = this.scope.querySelector('input[name="quantity"]');
        const quantity = Math.max(1, Number(input?.value) || 1);
        const price = this.surface.querySelector('[data-order-price]');
        if (price) price.textContent = ` · ${this.formatter.format(this.price * (this.dataset.priceMode === 'total' ? quantity : 1) / 100)}`;
        const count = this.surface.querySelector('[data-order-quantity]');
        if (count) count.textContent = ` × ${quantity}`;
        this.button.disabled = !this.available;
      };
      this.scope.addEventListener('input', this.sync, options);
      this.scope.addEventListener('change', event => {
        if (event.target.closest('variant-selects') || event.target.name === 'id') this.button.disabled = true;
        else this.sync();
      }, options);
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== this.scope.dataset.section) return;
        this.price = data.variant?.price || 0;
        this.available = Boolean(data.variant?.available);
        this.sync();
      });
      this.button.addEventListener('click', () => {
        const error = this.surface.querySelector('.atelier-order-error');
        error.hidden = true;
        const trigger = this.scope.querySelector('#es-popup-button, .es-popup-button-product, [data-tyslo-open], .tyslo-open') || document.querySelector('#es-popup-button');
        if (trigger && !trigger.disabled && !this.surface.contains(trigger)) {
          trigger.click();
        } else if (typeof window.openTysloForm === 'function') {
          window.openTysloForm();
        } else {
          error.textContent = this.dataset.error;
          error.hidden = false;
        }
      }, options);
      }
      this.media = matchMedia('(max-width:749px)');
      this.summary = this.scope.querySelector('.product__info-container');
      this.updateVisibility = () => {
        const desktopDisabled = !this.media.matches && this.dataset.desktopEnabled === 'false' && this.dataset.placement !== 'inline';
        const waiting = desktopDisabled || Boolean(this.spacer && !this.media.matches && this.dataset.desktopReveal !== 'always' && this.summary && this.summary.getBoundingClientRect().bottom > 0);
        this.surface.classList.toggle('atelier-order-surface--waiting', waiting);
        this.surface.inert = waiting;
        const barHeight = this.spacer && !waiting ? this.surface.getBoundingClientRect().height : 0;
        if (this.spacer) this.spacer.style.setProperty('--order-bar-height', `${barHeight}px`);
        // Reserve a stable gallery inset before revealing the desktop bar to avoid a sudden column jump.
        const galleryInset = this.spacer && !this.media.matches && !desktopDisabled ? this.surface.getBoundingClientRect().height : 0;
        this.scope.style.setProperty('--atelier-product-sticky-height', `${galleryInset}px`);
      };
      if (this.summary) {
        this.summaryObserver = new IntersectionObserver(this.updateVisibility, { threshold: 0 });
        this.summaryObserver.observe(this.summary);
      }
      this.position = () => {
        const sticky = this.dataset.placement === 'sticky' || (this.dataset.placement === 'mobile' && this.media.matches);
        if (sticky && !this.spacer) {
          this.surface.style.cssText = this.style.cssText;
          this.surface.style.marginBlock = '0';
          this.surface.classList.add('atelier-order-surface--sticky');
          this.spacer = document.createElement('div');
          this.spacer.className = 'atelier-order-spacer';
          document.body.append(this.surface, this.spacer);
          this.resize = new ResizeObserver(this.updateVisibility);
          this.resize.observe(this.surface);
          this.style.display = 'none';
        } else if (!sticky && this.spacer) {
          this.restore();
        }
        this.updateVisibility();
      };
      this.media.addEventListener('change', this.position, options);
      this.sync?.();
      this.position();
    }
    restore() {
      this.resize?.disconnect();
      this.spacer?.remove();
      this.spacer = null;
      this.surface.classList.remove('atelier-order-surface--sticky', 'atelier-order-surface--waiting');
      this.surface.inert = false;
      this.surface.removeAttribute('style');
      this.append(this.surface);
      this.style.removeProperty('display');
    }
    disconnectedCallback() {
      this.summaryObserver?.disconnect();
      this.scope?.style.removeProperty('--atelier-product-sticky-height');
      this.abort?.abort();
      this.unsubscribe?.();
      if (this.surface) this.restore();
    }
  });
}
